/* istanbul ignore file */
import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconPersonRunning({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
          d='M13.729 5.75a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5'
        />
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
          d='M19.794 4.78a1.5 1.5 0 0 0-1.765 1.176A2.86 2.86 0 0 1 16.912 8c-.7.405-1.884.342-3.437-.177-4.414-1.468-7.207-1.467-9.317 2.756a1.5 1.5 0 0 0 2.684 1.342c.78-1.56 1.189-2.37 3.7-1.815l-1.43 3.575v.012q-.051.128-.078.262v.02L8.79 15.15a4.31 4.31 0 0 1-3.39 3.39l-1.194.24A1.5 1.5 0 1 0 4.8 21.72l1.193-.24a7.29 7.29 0 0 0 5.472-4.78l.446.3a4.32 4.32 0 0 1 1.9 3.117l.2 1.8a1.5 1.5 0 0 0 2.982-.333l-.2-1.8a7.3 7.3 0 0 0-3.218-5.285l-1.23-.82 1.093-2.735a6.5 6.5 0 0 0 4.98-.343 5.68 5.68 0 0 0 2.553-4.055 1.5 1.5 0 0 0-1.177-1.768'
        />
      </svg>
    </>
  )
}
IconPersonRunning.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconPersonRunning
